import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";
import { isEmpty } from "lodash";

const deleteEvent = (eventId) => {
  return axios.post(
    API_URL + `/api/News/DeleteEvents/${eventId}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

const deleteEventCountdown = (id) => {
  return axios.post(
    API_URL + `/api/News/DeleteEventCountDown/${id}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

const fetchEventsById = async ({ id }) => {
  return await axios.get(API_URL + `/api/News/GetEventsById/${id}`, {
    headers: securityHeaders,
  });
};

const fetchEventCountdownById = async (id) => {
  return await axios.get(API_URL + `/api/News/GetEventCountDownById/${id}`, {
    headers: securityHeaders,
  });
};

const fetchEventCountdown = async (searchKey) => {
  return await axios.get(
    API_URL +
      `/api/News/GetEventCountdown${
        !isEmpty(searchKey) ? "?SearchBy=" + searchKey : ""
      }`,
    {
      headers: securityHeaders,
    }
  );
};

export const useDeleteEvent = (newsId) => {
  return useMutation(() => deleteEvent(newsId));
};

export const useDeleteEventCountdown = (id) => {
  return useMutation(() => deleteEventCountdown(id));
};

export const useFetchEventById = ({ id }) => {
  return useQuery({
    queryKey: [`eventsById-${id}`],
    queryFn: () => fetchEventsById({ id }),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchEventCountdownById = (id) => {
  return useQuery({
    queryKey: [`eventCountdown-${id}`],
    queryFn: () => fetchEventCountdownById(id),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchEventCountdown = (searchKey) => {
  return useQuery({
    queryKey: ["eventCountdown"],
    queryFn: () => fetchEventCountdown(searchKey),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};
